import { createSelector, createStructuredSelector } from 'reselect';
import { last, get, find, chunk } from 'lodash';
import { LocationResponse } from 'containers/ServicesPage/types';
import { SectionsProps } from 'containers/ContactsUtilsPage/types';

const getLastNotificationAUTO = (state: any) =>
  state.getIn(['global', 'lastNotificationAUTO']);

const getLastNotificationAMC = (state: any) =>
  state.getIn(['global', 'lastNotificationAMC']);

const getLastNotificationMRH = (state: any) =>
  state.getIn(['global', 'lastNotificationMRH']);

const getLastNotificationEpargn = (state: any) =>
  state.getIn(['global', 'lastNotificationEPARGN']);

const getLastNotificationASI = (state: any) =>
  state.getIn(['global', 'lastNotificationASI']);

const getAutoDetailsPageBreadcrumbsPath = (state: any) =>
  state.getIn(['global', 'autoDetailsPageBreadcrumbsPath']);

const getAmcDetailsPageBreadcrumbsPath = (state: any) =>
  state.getIn(['global', 'amcDetailsPageBreadcrumbsPath']);

const getASIDetailsPageBreadcrumbsPath = (state: any) =>
  state.getIn(['global', 'asiDetailsPageBreadcrumbsPath']);

const getMrhDetailsPageBreadcrumbsPath = (state: any) =>
  state.getIn(['global', 'mrhDetailsPageBreadcrumbsPath']);

const getEpargnDetailsPageBreadcrumbsPath = (state: any) =>
  state.getIn(['global', 'epargnDetailsPageBreadcrumbsPath']);

const getIsModalServicesAuto = (state: any) =>
  state.getIn(['global', 'openModalServicesAuto']);

const getIsModalServicesMrh = (state: any) =>
  state.getIn(['global', 'openModalServicesMrh']);

const getVimeoThumbnailSrc = (state: any) =>
  state.getIn(['global', 'vimeoThumbnailSrc']);
const getIsLoadingVimeoThumbnailSrc = (state: any) =>
  state.getIn(['global', 'isLoadingVimeoThumbnailSrc']);
const getVimeoThumbnailSrcErrorMessage = (state: any) =>
  state.getIn(['global', 'vimeoThumbnailSrcErrorMessage']);

const getToasterObj = (state: any) => state.getIn(['global', 'toaster']);

const getTabs = (state: any) => state.getIn(['global', 'tabs']);
const getFaqs = (state: any) => state.getIn(['global', 'faq']);
const selectedTabs = (state: any) => state.getIn(['global', 'selectedTab']);
const isReportBugLoading = (state: any) =>
  state.getIn(['global', 'isReportBugLoading']);

export const getLocationsSelector = (state: any): LocationResponse[] =>
  state.getIn(['global', 'locations']);
export const getSelectedFaqCode = (state: any) =>
  state.getIn(['global', 'SelectedCodeFaq']);
export const getSelectedFaqId = (state: any) =>
  state.getIn(['global', 'SelectedIdFaq']);
export const getContactsSelector = (
  state: any,
): { contacts: SectionsProps[]; isLoading: boolean } => ({
  contacts: state.getIn(['global', 'contacts']),
  isLoading: state.getIn(['global', 'isLoadingContacts']),
});

export const getLocationFilterSelector = (state: any): string =>
  state.getIn(['global', 'locationsFilter']);
export const getSearchFaq = (state: any) =>
  state.getIn(['global', 'searchedFAQ']);

export const getVimeoThumbnailSrcSelector = createSelector(
  getVimeoThumbnailSrc,
  (vimeoThumbnailSrc) => vimeoThumbnailSrc,
);
export const getIsLoadingVimeoThumbnailSrcSelector = createSelector(
  getIsLoadingVimeoThumbnailSrc,
  (isLoadingVimeoThumbnailSrc) => isLoadingVimeoThumbnailSrc,
);
export const getVimeoThumbnailSrcErrorMessageSelector = createSelector(
  getVimeoThumbnailSrcErrorMessage,
  (vimeoThumbnailSrcErrorMessage) => vimeoThumbnailSrcErrorMessage,
);

export const getLastNotificationAUTOSelector = createSelector(
  getLastNotificationAUTO,
  (notification) => notification,
);

export const getLastNotificationAMCSelector = createSelector(
  getLastNotificationAMC,
  (notification) => notification,
);

export const getLastNotificationMRHSelector = createSelector(
  getLastNotificationMRH,
  (notification) => notification,
);

export const getLastNotificationASISelector = createSelector(
  getLastNotificationASI,
  (notification) => notification,
);

export const getAutoDetailsPageBreadcrumbsPathSelector = createSelector(
  getAutoDetailsPageBreadcrumbsPath,
  (autoDetailsPageBreadcrumbsPath) => autoDetailsPageBreadcrumbsPath.toJS(),
);

export const getAmcDetailsPageBreadcrumbsPathSelector = createSelector(
  getAmcDetailsPageBreadcrumbsPath,
  (amcDetailsPageBreadcrumbsPath) => amcDetailsPageBreadcrumbsPath.toJS(),
);

export const getASIDetailsPageBreadcrumbsPathSelector = createSelector(
  getASIDetailsPageBreadcrumbsPath,
  (asiDetailsPageBreadcrumbsPath) => asiDetailsPageBreadcrumbsPath.toJS(),
);

export const getMrhDetailsPageBreadcrumbsPathSelector = createSelector(
  getMrhDetailsPageBreadcrumbsPath,
  (mrhDetailsPageBreadcrumbsPath) => mrhDetailsPageBreadcrumbsPath.toJS(),
);

export const getEpargnDetailsPageBreadcrumbsPathSelector = createSelector(
  getEpargnDetailsPageBreadcrumbsPath,
  (epargnDetailsPageBreadcrumbsPath) => epargnDetailsPageBreadcrumbsPath.toJS(),
);

export const getTabsSelector = createSelector(getTabs, (tabs) => tabs);

export const getFaqsSelector = createSelector(getFaqs, (faqs) => faqs);

export const getAutoDetailsPageSelectedTabValue = createSelector(
  getAutoDetailsPageBreadcrumbsPathSelector,
  (autoDetailsPageBreadcrumbsPath) => {
    const lastPathElement = last(autoDetailsPageBreadcrumbsPath);
    if (get(lastPathElement, 'name') === 'contractEtGarantie') return 1;
    else if (get(lastPathElement, 'name') === 'autoServices') return 2;
    else return 0;
  },
);

export const getAmcDetailsPageSelectedTabValue = createSelector(
  getAmcDetailsPageBreadcrumbsPathSelector,
  (amcDetailsPageBreadcrumbsPath) => {
    const lastPathElement = last(amcDetailsPageBreadcrumbsPath);
    if (get(lastPathElement, 'name') === 'contractEtGarantie') return 2;
    else if (get(lastPathElement, 'name') === 'suiviDesDemandes') return 1;
    else return 0;
  },
);

export const getASIDetailsPageSelectedTabValue = createSelector(
  getASIDetailsPageBreadcrumbsPathSelector,
  (asiDetailsPageBreadcrumbsPath) => {
    const lastPathElement = last(asiDetailsPageBreadcrumbsPath);
    if (get(lastPathElement, 'name') === 'contractEtGarantie') return 1;
    else return 0;
  },
);

export const getMrhDetailsPageSelectedTabValue = createSelector(
  getMrhDetailsPageBreadcrumbsPathSelector,
  (mrhDetailsPageBreadcrumbsPath) => {
    const lastPathElement = last(mrhDetailsPageBreadcrumbsPath);
    if (get(lastPathElement, 'name') === 'contractEtGarantie') return 1;
    else return 0;
  },
);

export const getEpargnDetailsPageSelectedTabValue = createSelector(
  getEpargnDetailsPageBreadcrumbsPathSelector,
  (epargnDetailsPageBreadcrumbsPath) => {
    const lastPathElement = last(epargnDetailsPageBreadcrumbsPath);
    if (get(lastPathElement, 'name') === 'mesContrats') return 1;
    else return 0;
  },
);

export const getIsModalServicesAutoSelector = createSelector(
  getIsModalServicesAuto,
  (getIsModalServicesAuto) => getIsModalServicesAuto,
);

export const getIsModalServicesMrhSelector = createSelector(
  getIsModalServicesMrh,
  (getIsModalServicesMrh) => getIsModalServicesMrh,
);

export const getToasterObjSelector = createSelector(
  getToasterObj,
  (getToasterObj) => getToasterObj.toJS(),
);
export const getSelectedTabSelector = createSelector(
  selectedTabs,
  (selectedTab) => selectedTab,
);

export const getLastNotificationEpargnSelector = createSelector(
  getLastNotificationEpargn,
  (notification) => notification,
);
export const isReportBugLoadingSelector = createSelector(
  isReportBugLoading,
  (isReportBugLoading) => isReportBugLoading,
);

export const getSearchFaqSelector = createSelector(
  getSearchFaq,
  (searchFaq) => searchFaq,
);
export const getAutoFaqSelector = createSelector(getFaqs, (faq) => {
  return get(chunk(get(find(faq, { code: 'auto' }), 'body'), 4), '0');
});
export const getMrhFaqSelector = createSelector(getFaqs, (faq) => {
  const MrhFaq = get(find(faq, { code: 'habitation' }), 'body');
  return get(chunk(MrhFaq, 4), '0');
});
export const getEpargnFaqSelector = createSelector(getFaqs, (faq) => {
  const EpargnFaq = get(find(faq, { code: 'epargn' }), 'body');
  return get(chunk(EpargnFaq, 4), '0');
});
export const getAMCFaqSelector = createSelector(getFaqs, (faq) => {
  const EpargnFaq = get(find(faq, { code: 'sante' }), 'body');
  return get(chunk(EpargnFaq, 4), '0');
});
export const getASIFaqSelector = createSelector(getFaqs, (faq) => {
  const AsiFaq = get(find(faq, { code: 'asi' }), 'body');
  return get(chunk(AsiFaq, 4), '0');
});
export const getSelectedFaqCodeSelector = createSelector(
  getSelectedFaqCode,
  (SelectedFaqCode) => SelectedFaqCode,
);
export const getSelectedFaqIdSelector = createSelector(
  getSelectedFaqId,
  (SelectedFaqId) => SelectedFaqId,
);
export const lastNotificationSelector = createStructuredSelector({
  AUTO: getLastNotificationAUTO,
  AMC: getLastNotificationAMC,
  MRH: getLastNotificationMRH,
  ASI: getLastNotificationASI,
  EPARGN: getLastNotificationEpargn,
});
